import React from 'react';
import { Modal } from 'react-bootstrap';
import IWebsite from '../../interfaces/IWebsite';
import { BtnSubmit } from '../inputs/btnSubmit';
import InputText from '../inputs/inputText';
import BaseComponent from '../baseComponent';
import IFormError from '../forms/IFormError';
import { filter } from 'lodash';
import IMenu from '../../interfaces/IMenu';

interface IState {
    form: {
        name: string,
        position: string,
    }
    loading: boolean,
    serverErrors: IFormError[]
}

interface IProps {
    website: IWebsite,
    onHide(): void,
    onCreated(menu: IMenu): void,
}

export default class CreateNewMenuModal extends BaseComponent<IProps, IState> {

    private inputName: React.RefObject<InputText>;
    private inputPosition: React.RefObject<InputText>;
 
    constructor(props: IProps) {
        super(props);

        this.state = {
            form: {
                name: '',
                position: '',
            },
            loading: false,
            serverErrors: []
        }

        this.inputName = React.createRef();
        this.inputPosition = React.createRef();
    }

    handleSubmit() {
        const inputs = [
            this.inputName,
            this.inputPosition,
        ];

        const isValid = this.validateInputs(inputs);
        const website = this.props.website;
        const form = this.state.form;

        if (isValid) {
            this.setState({
                loading: true
            })

            this.websitesApiService.createMenu(website.id, form.name, form.position)
                .then(data => {
                    if (data.success) {
                        const menu = data.records.menus.items[0];

                        this.props.onCreated(menu);
                        this.props.onHide();
                    }
                    else {
                        this.setState({
                            loading: false,
                            serverErrors: data.formErrors
                        })
                        this.validateInputs(inputs);
                    }      
                })
        }
    }

    handleChange(value: any, key: string) {
        this.setState({
            form: {
                ...this.state.form,
                [key]: value
            },
            serverErrors: filter(this.state.serverErrors, error => { if (error.key !== key) return true; else return false })
        })
    }

    render() {
        const { loading, form, serverErrors } = this.state;

        return (
            <Modal animation={false} centered={true} show onHide={this.props.onHide.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5>Vytvořit nové menu</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InputText
                        uid="name"
                        ref={this.inputName}
                        label="Název"
                        onChange={this.handleChange.bind(this)}
                        value={form.name}
                        required
                        maxLength={30}
                        serverErrors={serverErrors}
                    />

                    <InputText
                        uid="position"
                        ref={this.inputPosition}
                        label="Umístění"
                        onChange={this.handleChange.bind(this)}
                        value={form.position}
                        required
                        maxLength={30}
                        serverErrors={serverErrors}
                    />

                    <BtnSubmit
                        loading={loading}
                        onClick={this.handleSubmit.bind(this)}
                    >
                        Vytvořit
                    </BtnSubmit>
                </Modal.Body>
            </Modal>
        )
    }
}